var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"header":"Billing","header-bg-variant":_vm.bgVariant}},[(!_vm.order.billingAddress)?_c('div',[_vm._v("\n    Loading...\n  ")]):_c('div',[_c('address-info',{attrs:{"address":_vm.order.billingAddress,"is-shipping":false}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3713d9f9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/node_modules/vue-loader/lib/selector.js?type=template&index=0!/src/components/sales-order/view-order-2/BillingAddress.vue
// module id = null
// module chunks = 